var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticClass:"btn facebook-btn",attrs:{"icon":"facebook","disabled":_vm.disabled},on:{"click":function (e) { return _vm.$emit('click', e); }}},[_vm._v("Facebook")])}
var staticRenderFns = []

export { render, staticRenderFns }